import { useLocation, useNavigate, useParams } from 'react-router-dom';
import './storyPage.css'
import Talk from '../components/talk';
import { useEffect, useState } from 'react';
import axios from 'axios';

export default function StoryPage (){
    const navigate = useNavigate()
    const location = useLocation()
    const [story, setStory] = useState(location.state?.storyData)

    useEffect(() => {
        window.scrollTo(0, 0);
        return () => {
          window.scrollTo(0, 0);
        };
    }, []); 

    const {Id} = useParams()
    const storyId = atob(Id).split("_")[1]
    useEffect(()=>{
        const fetchData=async()=>{
            try{
                const response = await axios.get(`${process.env.React_APP_API_URL}/api/v1/story/${storyId}`);
                if(response.status===200){
                    console.log(response)
                    setStory(response.data[0])
                }
            }catch(err) {
                console.log(err)
            }
        }
        story || fetchData()
    },[])

    
    const [mainImage, setMainImage] = useState()
    const [selectedStory, setselectedStory] = useState('one')

    useEffect(()=>{
        if(story){
            switch (selectedStory) {
                case 'one':
                    setMainImage(story.image1)
                    break;
                case 'two':
                    setMainImage(story.image2)
                    break;
                case 'three':
                    setMainImage(story.image3)
                    break;
                case 'four':
                    setMainImage(story.image4)
                    break;
                default:
                    break;
            }
        }
    },[selectedStory, story])

    //Home Estimator Form
    const [homeEst, sethomeEst] = useState({
        pincode:'',
        bill:'',
        area:'',
        type:''
    })
    const homeEstChange = (e) =>{
        const {name, value}=e.target
        sethomeEst((preData)=>({
            ...preData,
            [name]:value,
        }))
    }
    const homeEstSubmit = (e) =>{
        e.preventDefault()
        console.log(homeEst)
    }
    if(story){
        return(
            <div className='storyPageWrapper'>
                <div className='filterBack' onClick={()=> navigate(-1)}>
                            <img src='../images/back.svg' alt='back'/>
                        </div>
                <div className='storyPageTitle'>
                    <h1>{story.storytitle}</h1>
                    <p>{story.storylocation}</p>
                </div>
                <div className='storyPageContainer'>
                    <div className='storyImageContainer'>
                        <div className='storyMainImage'>
                            <img src={`${process.env.React_APP_API_URL}/upload/${mainImage}`} alt=''/>
                        </div>
                        <div className='storyImages'>
                            <div className={selectedStory==='one'?'storyImage selectedImage':'storyImage'} onClick={()=>setselectedStory('one')}>
                                <img src={`${process.env.React_APP_API_URL}/upload/${story.image1}`} alt=''/>
                            </div>
                            <div className={selectedStory==='two'?'storyImage selectedImage':'storyImage'} onClick={()=>setselectedStory('two')}>
                                <img src={`${process.env.React_APP_API_URL}/upload/${story.image2}`} alt=''/>
                            </div>
                            <div className={selectedStory==='three'?'storyImage selectedImage':'storyImage'} onClick={()=>setselectedStory('three')}>
                                <img src={`${process.env.React_APP_API_URL}/upload/${story.image3}`} alt=''/>
                            </div>
                            <div className={selectedStory==='four'?'storyImage selectedImage':'storyImage'} onClick={()=>setselectedStory('four')}>
                                <img src={`${process.env.React_APP_API_URL}/upload/${story.image4}`} alt=''/>
                            </div>
                        </div>
                    </div>
                    <div className='storyPageDescription'>
                        <h2>Highlights</h2>
                        <div className='storyHighContainer'>
                            <div className='storyHigh'>
                                <p>Power Generation</p>
                                <h3>{story.storygen} KW</h3>
                            </div>
                            <div className='storyHigh'>
                                <p>Savings</p>
                                <h3>Rs {story.storysave}</h3>
                            </div>
                        </div>
                        <h2>Story</h2>
                        <p>
                        {story.storystory}
                        </p>
                    </div>
                </div>
                {/* <div className='hero-estimator-container'>
                    <form onSubmit={homeEstSubmit}>
                        <div className='hero-input-container'>
                            <input
                                type='number'
                                name='pincode'
                                placeholder='pincode'
                                value={homeEst.name}
                                onChange={homeEstChange}
                                required
                            />
                            <label>Pincode</label>
                        </div>
                        <div className='hero-input-container'>
                            <input
                                type='number'
                                name='bill'
                                placeholder='Average Bill'
                                value={homeEst.bill}
                                onChange={homeEstChange}
                                required
                            />
                            <label>Average Bill</label>
                        </div>
                        <div className='hero-input-container'>
                            <input
                                type='number'
                                name='area'
                                placeholder='Roof Area'
                                value={homeEst.area}
                                onChange={homeEstChange}
                                required
                            />
                            <label>Roof Area</label>
                        </div>
                        <div className='hero-input-container'>
                            <select
                                name='type'
                                value={homeEst.type}
                                onChange={homeEstChange}
                                required
                            >
                                <option value='' hidden>Property Type</option>
                                <option value='residential'>Residential</option>
                                <option value='commertial' >Commertial</option>
                            </select>
                        </div>
                        <div className='hero-input-container'>
                            <input
                                type='submit'
                                value='Design'
                            />
                        </div>
                    </form>                    
                </div>   */}
                <div className='contactUS estTAlk'>
                    <Talk/>
                </div>             
            </div>
        );
    }
} 